export const TAG_FIELDS = `
  id
  name
  campaign
  channel
  linkItem
  dataTrack
  tactic
  internalCmpId
  internalCmpDocket
  internalCmpName
  internalCmpType
  internalCmpCreative 
  `;

export const ALL_TAGS = `
tags {
  id
  name
  campaign
  channel
  linkItem
  dataTrack
  tactic
  internalCmpId
  internalCmpDocket
  internalCmpName
  internalCmpType
  internalCmpCreative 
}
`;

export const BUTTON_FRAGMENT = `
  id
  slug
  label
  href
  descriptiveText
  variant
  size
  theme
  openInNewTab
`;

export const AD_PAGE_FRAGMENT = `
  id
  active
  path
  targetingPosition
  adSlot {
    id
    sizeMappings
  }
`;

export const ALL_OFFERS = `
  offer {
  id
  name
  couponCode
  slug
  imageUrl
  tags {
    ${TAG_FIELDS}
  }
  fullHeader
  shortHeader
  affiliateUrl
  imageAltText
  shortDescription
  termsAndConditions
  startDate
  endDate
  recencyOfOffersDays
  descriptiveText
  prepositionKey
  linkTextPrepositions
  offerTypes {
    id
    name
    slug
    visibleInOffer
  }
  categories {
    id
    name
    slug
    metaDescription
    subCategories {
      id
    }
    isInCategoryNav
    isFilterOptions
    heroImageUrl
    heroAltText
    categoryIconUrl
    tags {
      ${TAG_FIELDS}
    }
    shops {
      id
    }
    offers {
      id
    }
  }
  config {
    singularMilesText
    pluralMilesText
    singularFlatRateMilesText
    pluralFlatRateMilesText
    exclusionsApplyText
    primaryText
    primaryButtonTagSet {
      ${TAG_FIELDS}
    }
    secondaryText
    secondaryButtonTagSet {
      ${TAG_FIELDS}
    }
    milesBadgeText
    codeText
    endsText
    couponDisclaimerText
    modalButtonOneText
    modalButtonOneTagSet {
      ${TAG_FIELDS}
    }
    modalButtonTwoText
    modalButtonTwoTagSet {
      ${TAG_FIELDS}
    }
    modalButtonTwoTextSaved
    modalButtonTwoTagSetSaved {
      ${TAG_FIELDS}
    }
    modalButtonThreeText
    modalButtonThreeTagSet {
      ${TAG_FIELDS}
    }
    modalCouponCodeTitle
    modalTermsAndConditionsTitle
    favouriteAddLabel
    favouriteRemoveLabel
  }
  exclusionsApply
}
`;

export const ALL_OFFER_TYPES = `
offerType {
  name
  slug
}
`;

export const ALL_CATEGORIES = `
category {
  name
  slug
}
`;

export const ALL_GLOBAL_MULTIPLIER_CONFIGS = `
globalMultiplierConfig {
  id
  name
  value
  startDate
  endDate
  shops {
    id
    slug
    name
  }
}
`;

export const ALL_GLOBAL_PAGE_CONFIGS = `
globalPageConfig {
  id
  name
  defaultMetaDescription
  pageTitleBase
  pageRefs
  modalCloseButtonText
  modalCloseButtonTagSet {
    ${TAG_FIELDS}
  }
  shopsDirectoryTabTitle
  categoriesDirectoryTabTitle
  categoryDirectoryParentCategoryPrefix
  sessionExtensionHeadingText
  sessionExtensionBodyText
  sessionExtensionSignInText
  sessionExtensionSignOutText
  linkTextPrepositions
  globalBannerLabel
  skipContentLabel
  myZoneHeadingLabel
  closeIconLabel
  allShopsHeadingLabel
  searchHeadingLabel
  heartIconActiveTitle
  heartIconInactiveTitle
  backButtonText
  backToCategoriesButtonText
  isOneBalanceEnabled
  thousandsSeparator
  balanceLabel
}
`;

export const ALL_GLOBAL_PAGE_CONFIGS_PAGE_TITLE = `
globalPageConfig {
  pageTitleBase
}
`;

export const ALL_NAVIGATION_SEARCH_BARS = `
navigationSearchBar {
  id
  name
  searchBarPlaceholderText
  searchHeaderText
  searchStoreTitle
  searchCategoriesTitle
  searchCtaButtonText
  searchIconLabel
  clearSearchLabel
  menuToggleOpen
  menuToggleClose
  airmilesLogoNavSlot {
    id
    name
    text
    url
    openInNewTab
    ${ALL_TAGS}
  }
  shopsLogoNavSlot {
    id
    name
    text
    url
    ${ALL_TAGS}
  }
}
`;

const ROOT_CATEGORY_FRAGMENT = `
rootCategory {
  name
  slug
  isInCategoryNav
  categoryIconUrl
  sidebarToggleOpen
  sidebarToggleClose
  subCategories {
    featureShops {
      name
      affiliateUrl
      mediumImageAltText
      mediumImageUrl
      slug
      tags {
        ${TAG_FIELDS}
      }
      displayName
      linkTextPrepositions
      config {
        primaryText
        secondaryText
      }
    }
    name
    slug
    analyticsSlug
    isInCategoryNav
    categoryIconUrl
    sidebarToggleOpen
    sidebarToggleClose
    tags {
      ${TAG_FIELDS}
    }
  
    shops {
      name
      affiliateUrl
      slug
      mediumImageUrl
      mediumImageAltText
      
      tags {
        ${TAG_FIELDS}
      }
      displayName
      linkTextPrepositions
      config {
        primaryText
        secondaryText
      }
    }

    subCategories{
      name
      slug
      analyticsSlug
      
      tags {
        ${TAG_FIELDS}
      }
    }
  }
}
`;

export const ALL_NAVIGATION_CATEGORY_BARS = `
navigationCategoriesBar {
  id
  name
  linkOneUrl
  linkOneText
  linkOneAnalyticsSlug
  linkOneTagSet {
    ${TAG_FIELDS}
  }
  linkTwoUrl
  linkTwoText
  linkTwoAnalyticsSlug
  linkTwoTagSet {
    ${TAG_FIELDS}
  }
  myZoneDropdownTitle
  moreDropdownTitle
  firstNavSlots {
    name
    analyticsSlug
    text
    descriptiveText
    url
    openInNewTab
    showAsDropdown
    boldText
    buttonStyle
    navSlotPurpose
    startDate
    endDate
    dropdownEntries {
      name
      analyticsSlug
      text
      descriptiveText
      url
      openInNewTab
      showAsDropdown
      icon
      tags {
        ${TAG_FIELDS}
      }
    }
    tags {
      ${TAG_FIELDS}
    }
    ${ROOT_CATEGORY_FRAGMENT}
  }
  secondNavSlots {
    name
    analyticsSlug
    text
    descriptiveText
    url
    openInNewTab
    showAsDropdown
    boldText
    buttonStyle
    navSlotPurpose
    startDate
    endDate
    dropdownEntries {
      name
      analyticsSlug
      text
      descriptiveText
      url
      openInNewTab
      showAsDropdown
      icon
      navSlotPurpose
      tags {
        ${TAG_FIELDS}
      }
    }
    tags {
      ${TAG_FIELDS}
    }
  }
  anonFirstNavSlots {
    name
    analyticsSlug
    text
    descriptiveText
    url
    openInNewTab
    showAsDropdown
    boldText
    buttonStyle
    navSlotPurpose
    startDate
    endDate
    dropdownEntries {
      name
      analyticsSlug
      text
      descriptiveText
      url
      openInNewTab
      showAsDropdown
      tags {
        ${TAG_FIELDS}
      }
    }
    tags {
      ${TAG_FIELDS}
    }
    ${ROOT_CATEGORY_FRAGMENT}
  }
  anonSecondNavSlots {
    name
    analyticsSlug
    text
    descriptiveText
    url
    openInNewTab
    showAsDropdown
    boldText
    buttonStyle
    navSlotPurpose
    startDate
    endDate
    dropdownEntries {
      name
      analyticsSlug
      text
      descriptiveText
      url
      openInNewTab
      showAsDropdown
      tags {
        ${TAG_FIELDS}
      }
    }
    tags {
      ${TAG_FIELDS}
    }
  }
}
`;

const NAV_SLOT_FIELDS = `
  name
  analyticsSlug
  text
  descriptiveText
  url
  openInNewTab
  showAsDropdown
  boldText
  buttonStyle
  navSlotPurpose
  icon
  startDate
  endDate
  dropdownEntries {
    name
    text
    descriptiveText
    url
    openInNewTab
    showAsDropdown
    icon
    headerText
    bodyText
    backgroundColor
    tags {
      ${TAG_FIELDS}
    }
  }
  tags {
    ${TAG_FIELDS}
  }
`;

export const GLOBAL_NAVIGATION = `
globalNavigation {
  siteNavSlots {
    ${NAV_SLOT_FIELDS}
  }
  anonNavSlots {
    ${NAV_SLOT_FIELDS}
  }
  balanceNavSlots {
    ${NAV_SLOT_FIELDS}
  }
  navSlots {
    ${NAV_SLOT_FIELDS}
  }
}
`;

export const ALL_FOOTERS = `
footer {
  id
  name
  copyrightText
  firstRow {
    name
    analyticsSlug
    text
    descriptiveText
    url
    tags {
      ${TAG_FIELDS}
    }
    openInNewTab
  }
  secondRow {
    name
    analyticsSlug
    text
    descriptiveText
    url
    tags {
      ${TAG_FIELDS}
    }
    openInNewTab
  }
  thirdRow {
    name
    analyticsSlug
    url
    tags {
      ${TAG_FIELDS}
    }
    openInNewTab
    iconUrl
    iconAltText
  }
  airmilesLogoNavSlot {
    id
    name
    text
    url
    openInNewTab
    ${ALL_TAGS}
  }
  shopsLogoNavSlot {
    id
    name
    text
    url
    openInNewTab
    ${ALL_TAGS}
  }
}
`;

export const OFFER_CARD_FRAGMENT = `
id
name
couponCode
shop {
  slug
  displayName
  categoryOrder
  mediumImageUrl
  mediumImageAltText
  baseMiles
  amountPerBaseMiles
  imageTitleTag
  linkTextPrepositions
  multiplier {
    endDate
    value
    startDate
  }
  siteWideMultiplier{
    value
    startDate
    endDate
  }
  broker {
    sessionParameter
  }
  config {
    extraMilesText
  }
}
slug
imageUrl
imageAltText
shortDescription
shortHeader
affiliateUrl
startDate
endDate
recencyOfOffersDays
exclusionsApply
descriptiveText
prepositionKey
linkTextPrepositions
termsAndConditions
offerTypes {
  name
  visibleInOffer
}
config {
  singularMilesText
  pluralMilesText
  singularFlatRateMilesText
  pluralFlatRateMilesText
  exclusionsApplyText
  primaryText
  primaryButtonTagSet {
    ${TAG_FIELDS}
  }
  secondaryText
  secondaryButtonTagSet {
    ${TAG_FIELDS}
  }
  milesBadgeText
  codeText
  endsText
  couponDisclaimerText
  modalButtonOneText
  modalButtonOneTagSet {
    ${TAG_FIELDS}
  }
  modalButtonTwoText
  modalButtonTwoTagSet {
    ${TAG_FIELDS}
  }
  modalButtonTwoTextSaved
  modalButtonTwoTagSetSaved {
    ${TAG_FIELDS}
  }
  modalButtonThreeText
  modalButtonThreeTagSet {
    ${TAG_FIELDS}
  }
  modalCouponCodeTitle
  modalTermsAndConditionsTitle
  favouriteAddLabel
  favouriteRemoveLabel
}
${ALL_TAGS}
`;

export const LAYOUT_LIFESTYLE_BANNER_FRAGMENT = `
  contentType
  name
  slug
  textOverlay
  textOverlayWidth
  buttonText
  buttonDescriptiveText
  buttonUrl
  heroImageAltText
  heroImageUrl
  verticalHeroImageUrl
  tags {
    ${TAG_FIELDS}
  }
  startDate
  endDate
  hexColorForTextOverlay
  buttonsDisplayTheme
  backgroundColor
  subtitle
  secondaryButtonText
  secondaryButtonDescriptiveText
  secondaryButtonUrl
  showDatesLabel
`;

export const HERO_BANNER_FRAGMENT = `
  id
  slug
  heading
  subheading
  buttons {
    ${BUTTON_FRAGMENT}
  }
  heroImageUrl
  portraitTabletHeroImageUrl
  heroImageAltText
  tags {
    ${TAG_FIELDS}
  }
  startDate
  endDate
  textColor
  backgroundColor
  showDatesLabel
  shouldReverseLayout
`;

export const LAYOUT_CAROUSEL_CONTAINER_FRAGMENT = `
  name
  slug
  contentType
  backgroundColor
  controlsTheme
  controlsTopMargin
  items {
    __typename
    ... on heroBanner {
      ${HERO_BANNER_FRAGMENT}
    }
  }
`;

export const LAYOUT_FRAGMENTS = `
... on layoutCarouselContainer {
  ${LAYOUT_CAROUSEL_CONTAINER_FRAGMENT}
}
... on googleAd {
  __typename
  id
  active
}
... on layoutLifestyleBanner {
  ${LAYOUT_LIFESTYLE_BANNER_FRAGMENT}
}
... on layoutCollectionView {
  contentType
  itemType
  viewType
  displayName
  showDisplayName
  buttonText
  buttonUrl
  slug
  tags {
    ${TAG_FIELDS}
  }
  shops {
    id
    displayName
    slug
    categoryOrder,
    active
    affiliateUrl
    recencyOfOffersDays
    exclusionsApply
    baseMiles
    amountPerBaseMiles
    imageTitleTag
    mediumImageUrl
    mediumImageAltText
    linkTextPrepositions
    broker {
      sessionParameter
    } 
    multiplier {
      value
      startDate
      endDate
    }
    siteWideMultiplier{
      value
      startDate
      endDate
    }
    config {
      milesBadgeText
      exclusionsApplyText
      primaryText
      primaryButtonTagSet {
        ${TAG_FIELDS}
      }
      secondaryText
      secondaryButtonTagSet {
        ${TAG_FIELDS}
      }
      singularMilesText
      pluralMilesText
      singularFlatRateMilesText
      pluralFlatRateMilesText
      favouriteAddLabel
      favouriteRemoveLabel
      extraMilesText
    }
    ${ALL_TAGS}
  }
  offers {
    ${OFFER_CARD_FRAGMENT}
  }
}
... on adContainer {
  contentType
  displayName
  name
  slug
  ads {
    imageUrl
    imageAltText
    name
    slug
    headerText
    subHeaderText
    primaryButtonText
    primaryButtonDescriptiveText
    primaryButtonUrl
    secondaryButtonText
    secondaryButtonDescriptiveText
    secondaryButtonUrl
    liveDate
    expirationDate
    expiryText
    shop {
      displayName
      mediumImageUrl
      mediumImageAltText
      baseMiles
      amountPerBaseMiles
      slug
      exclusionsApply
      multiplier {
        value
        startDate
        endDate
      }
      siteWideMultiplier{
        value
        startDate
        endDate
      }

      config {
        milesBadgeText
        exclusionsApplyText
        primaryText
        primaryButtonTagSet {
          ${TAG_FIELDS}
        }
        secondaryText
        secondaryButtonTagSet {
          ${TAG_FIELDS}
        }
        singularMilesText
        pluralMilesText
        singularFlatRateMilesText
        pluralFlatRateMilesText
        favouriteAddLabel
        favouriteRemoveLabel
        extraMilesText
      }
    }
    tags {
      ${TAG_FIELDS}
    }
    prepositionKey
    linkTextPrepositions
  }
} 
... on promoContainer {
  contentType
  name
  slug
  promos {
    name
    slug
    textOverlay
    promoUrl
    heroImageUrl
    tags {
      name
      campaign
      channel
      linkItem
      dataTrack
      tactic
    }
  }
}
... on layoutSmallPromoBanner {
  contentType
  name
  id
  slug
  headerText
  subHeaderText
  imageAltText
  buttonUrl
  buttonText
  imageUrl
  tags {
    ${TAG_FIELDS}
  }
}
`;

export const ALL_NOTIFICATION_SLOTS = `
notificationSlot {
  id
  name
  items {
    id
    name
    type
    headerText
    message
    mobileHeaderText
    mobileMessage
    linkUrl
    linkText
    startDate
    endDate
    displayFrequency
  }
}
`;

export const ALL_GLOBAL_BANNERS = `
globalBannerComponent {
  id
  name
  headerText
  subHeaderText
  mobileText
  redirectUrl
  hexForBackground
  backgroundImageUrl
  startDate
  endDate
  hexForFont
  multiplierValue
  backgroundImageAltText
  ${ALL_TAGS}
}
`;

export const ALL_GLOBAL_AD = `
globalAdConfig {
  id
  name
  primaryButtonText
  secondaryButtonText
  expiryText
  exclusionsApplyText
}
`;

export const ALL_GLOBAL_GREETING_SECTION_CONFIGS = `
globalGreetingSectionConfig {
  id
  name
  userLoggedInZeroFavouriteShopsLineOne
  userLoggedInZeroFavouriteShopsLineTwo
  userLoggedInZeroFavouriteShopsImage
  userLoggedInZeroFavouriteShopsImageAltText
  userLoggedInZeroFavouriteShopsCtaText
  userLoggedInZeroFavouriteShopsCtaUrl,
  userLoggedInZeroFavouriteShopsCtaTagSet {
    ${TAG_FIELDS}
  }
  userLoggedInWithFavouriteShopsLineOne
  userLoggedInWithFavouriteShopsLineTwo
  userLoggedInWithFavouriteShopsCtaText
  userLoggedInWithFavouriteShopsCtaUrl,
  userLoggedInWithFavouriteShopsCtaTagSet {
    ${TAG_FIELDS}
  }
  greetingSectionLayoutPosition
}
`;

export const SHOPS_BY_IDS = `
query shopsByIds($ids: [String!]) {
    shopsByIds: shop(ids: $ids){
      id
      displayName
      categoryOrder,
      slug
      active
      affiliateUrl
      recencyOfOffersDays
      exclusionsApply
      baseMiles
      amountPerBaseMiles
      imageTitleTag
      mediumImageUrl
      mediumImageAltText
      linkTextPrepositions
      broker {
        sessionParameter
      }   
      multiplier {
        value
        startDate
        endDate
      }
      siteWideMultiplier{
        value
        startDate
        endDate
      }
      config {
        milesBadgeText
        exclusionsApplyText
        primaryText
        primaryButtonTagSet {
          ${TAG_FIELDS}
        }
        secondaryText
        secondaryButtonTagSet {
          ${TAG_FIELDS}
        }
        singularMilesText
        pluralMilesText
        singularFlatRateMilesText
        pluralFlatRateMilesText
        favouriteAddLabel
        favouriteRemoveLabel
        extraMilesText
      }
      ${ALL_TAGS}
    }
  }`;

export const OFFERS_BY_IDS = `
query offersByIds($ids: [String!]) {
  offersByIds: offer(ids: $ids) {
    ${OFFER_CARD_FRAGMENT}
  }
}`;

export const SHOPS_BY_SLUG = `
query shop($shopSlug: String! ) {
  shop(slug: $shopSlug) {
    id
    name
    slug
    categoryOrder,
    pageTitle
    metaDescription
    displayName
    liveDate
    affiliateUrl
    mediumImageUrl
    mediumImageAltText
    heroBannerAltText
    heroBannerImageUrl
    largeDescription
    deliveryInformation
    baseMiles
    amountPerBaseMiles
    freeShipping
    freeDuties
    exclusionsApply
    currency
    importantInformation
    imageTitleTag
    linkTextPrepositions
    multiplier {
      value
      startDate
      endDate
    }
    siteWideMultiplier{
      value
      startDate
      endDate
    }
    broker {
      sessionParameter
    }
    offers {
      id
      shop {
        name
        slug
      }
      imageUrl
      tags {
        channel
      }
      name
      couponCode
      slug
      fullHeader
      affiliateUrl
      imageAltText
      shortDescription
      termsAndConditions
      startDate
      endDate
      recencyOfOffersDays
      descriptiveText
      prepositionKey
      linkTextPrepositions
      offerTypes {
        slug
        name
      }
    }
    layout {
      ${LAYOUT_FRAGMENTS}
    }
    config {
      milesBadgeText
      milesEndsText
      exclusionsApplyText
      primaryText
      primaryButtonTagSet {
        ${TAG_FIELDS}
      }
      secondaryText
      secondaryButtonTagSet {
        ${TAG_FIELDS}
      }
      singularMilesText
      pluralMilesText
      singularFlatRateMilesText
      pluralFlatRateMilesText
      favouriteButtonText
      favouriteButtonTagSet {
        ${TAG_FIELDS}
      }
      favouritedButtonText
      favouritedButtonTagSet {
        ${TAG_FIELDS}
      }
      shopCurrencyTitle
      shopDeliveryTitle
      shopCategoriesTitle
      aboutSectionTitle
      importantInformationSectionTitle
      favouriteAddLabel
      favouriteRemoveLabel
      extraMilesText
    }
    categories {
      name
      slug
      tags {
        ${TAG_FIELDS}
      }
    }
  }
  shopConfig {
    sectionTitleForOffers
  }
  category {
    slug
    isInCategoryNav
    subCategories {
      slug
    }
  }
}`;

export const CATEGORY_BY_SLUG = `
query category($categorySlug: String!, $adsPageSlug: String) {
  category(slug: $categorySlug) {
    name
    slug
    analyticsSlug
    metaDescription      
    heroImageUrl
    heroAltText
    subHeroLayout {
      ${LAYOUT_FRAGMENTS}
    }
    layout {
       ${LAYOUT_FRAGMENTS}
    }
    offers {
      ${OFFER_CARD_FRAGMENT}
    }
    subCategories {
      name
      slug
      analyticsSlug
    }
  }
  globalCategoryConfig {
    clearFiltersText
    cancelFilterText
    filterSectionTitleText
    subcategoryFilterTitleText
    applyFilterButtonText
    storesTabText
    offersTabText
    storesLayoutTitleText
    storesLayoutButtonText
    storesLayoutButtonUrl
    storesLayoutButtonTagSet {
      ${TAG_FIELDS}
    }
    offersLayoutTitleText
    offersLayoutButtonText
    offersLayoutButtonUrl
    offersLayoutButtonTagSet {
      ${TAG_FIELDS}
    }
    sidebarToggleOpen
    sidebarToggleClose
  }
  pageAds(pageSlug: $adsPageSlug) {
    ${AD_PAGE_FRAGMENT}
  }
}
`;

export const ONBOARDING_MODAL = `
onboardingModal {
  name
  headerText
  headerTextLogo
  subHeaderText
  buttonText
  secondaryButton {
    ${BUTTON_FRAGMENT}
  }
  tags {
    ${TAG_FIELDS}
  }
  buttonUrl
  slots {
    id
    headerText
    subHeaderText
    imageUrl
  }
  bottomBannerHeaderText
  bottomBannerSubHeaderText
}
`;

export const SITEMAP_PAGE = `
siteMapPage {
  name
  pageTitle
  displayName
  slug
  metaDescription
  sectionTitle {
    name
    displayName
    slug
  }
}
`;

export const SITEMAP_LINKS = `
  allShops: shop {
    id
    active
    name
    displayName
    slug
    affiliateUrl
    tags {
      ${TAG_FIELDS}
    }
  }
  allCategories: category {
    id
    name
    slug
    isInCategoryNav
    subCategories {
      id
      name
      slug
      tags {
        ${TAG_FIELDS}
      }
      isInCategoryNav
    }
  }
  allFooters: ${ALL_FOOTERS}
  allNavigationCategoriesBarLinks: navigationCategoriesBar {
    firstNavSlots {
      name
      text
      descriptiveText
      url
      navSlotPurpose
      tags {
        ${TAG_FIELDS}
       }
      dropdownEntries {
        name
        text
        descriptiveText
        url
        tags {
          ${TAG_FIELDS}
       }
      }
    }
    secondNavSlots {
      name
      text
      descriptiveText
      url
      navSlotPurpose
      tags {
        ${TAG_FIELDS}
       }
      dropdownEntries {
        name
        text
        descriptiveText
        url
        tags {
          ${TAG_FIELDS}
       }
      }
    }
    anonFirstNavSlots {
      name
      text
      descriptiveText
      url
      navSlotPurpose
      tags {
        ${TAG_FIELDS}
       }
      dropdownEntries {
        name
        text
        descriptiveText
        url
        tags {
          ${TAG_FIELDS}
       }
      }
    }
    anonSecondNavSlots {
      name
      text
      descriptiveText
      url
      navSlotPurpose
      tags {
        ${TAG_FIELDS}
       }
      dropdownEntries {
        name
        text
        descriptiveText
        url
        tags {
          ${TAG_FIELDS}
       }
      }
    }
  }
  allSeasonalLinks: seasonalPage {
    displayName
    slug
    active
  }
  allNotFoundLinks: notFoundPage {
    name
    slug
  }
`;

export const ALL_ANALYTICS_MANAGERS = `
  {
    analyticsManager {
      scriptTag
      scriptTagBody
    }
  }
`;

export const FULL_SHOP_DATA = `
  id
  active
  categoryOrder,
  locationCode
  name
  displayName
  slug
  affiliateUrl
  liveDate
  active
  baseMiles
  amountPerBaseMiles
  currency
  pageTitle
  recencyOfOffersDays
  mediumImageAltText
  mediumImageUrl
  heroBannerAltText
  exclusionsApply
  imageTitleTag
  linkTextPrepositions
  broker {
    name
    sessionParameter
  }
  categories {
    name
  }
  config {
    singularMilesText
    pluralMilesText
    singularFlatRateMilesText
    pluralFlatRateMilesText
    primaryText
    secondaryText
    exclusionsApplyText
    milesBadgeText
    primaryButtonTagSet {
      ${TAG_FIELDS}
    }
    secondaryButtonTagSet {
      ${TAG_FIELDS}
    }
    favouriteAddLabel
    favouriteRemoveLabel
  }
  multiplier {
    endDate
    startDate
    value
  }
  siteWideMultiplier{
    value
    startDate
    endDate
  }
  tags {
    id
    name
    campaign
    channel
    linkItem
    dataTrack
    tactic
  }
  layout {
    ${LAYOUT_FRAGMENTS}
  }
`;

export const GET_PAGE_ADS = (pageSlug) => (`
  pageAds(pageSlug: "${pageSlug}") {
    ${AD_PAGE_FRAGMENT}
  }
`);
